import { APIFieldType } from '@ardoq/api-types';
import type { I18nLocale } from '@ardoq/i18n';
import { Locale } from '@ardoq/locale';
import { fieldValueFormatters } from './fieldValueFormatters';
import type { TextAreaFormat } from '@ardoq/data-model';
import type { FormatUserFieldFn } from './fieldUtils';

type FormatFieldValueToTextArgs = {
  type: APIFieldType;
  fieldName: string;
  value: any;
  locale: Locale;
  i18nLocale: I18nLocale;
  excludeTime?: boolean;
  textAreaFormat?: TextAreaFormat;
  numberFormatOption?: string;
  // temporary workaround for user fields, currently scope data does not contain these users
  formatUserField: FormatUserFieldFn;
};
const formatFieldValueToText = ({
  type,
  value,
  locale,
  i18nLocale,
  excludeTime,
  textAreaFormat,
  numberFormatOption,
  fieldName,
  formatUserField,
}: FormatFieldValueToTextArgs) => {
  switch (type) {
    case APIFieldType.CHECKBOX:
    case APIFieldType.TEXT:
    case APIFieldType.EMAIL:
    case APIFieldType.URL:
    case APIFieldType.LIST:
      return fieldValueFormatters.stringValue(value);

    case APIFieldType.TEXT_AREA:
      switch (textAreaFormat) {
        case 'text':
          return fieldValueFormatters.formatTextAreaFieldValue(value, false);
        case 'html':
          return fieldValueFormatters.formatTextAreaFieldValue(value, true);
        default:
        case 'raw':
          return fieldValueFormatters.stringValue(value);
      }
    case APIFieldType.NUMBER:
      return fieldValueFormatters.formatNumberFieldValue({
        value,
        numberFormatOption,
        locale,
      });

    case APIFieldType.DATE_ONLY:
      return fieldValueFormatters.formatDateTimeFieldValue({
        value,
        locale,
        i18nLocale,
        fieldName,
        excludeTime: true,
      });

    case APIFieldType.DATE_TIME:
      return fieldValueFormatters.formatDateTimeFieldValue({
        value,
        locale,
        i18nLocale,
        fieldName,
        excludeTime,
      });

    case APIFieldType.SELECT_MULTIPLE_LIST:
      return fieldValueFormatters.formatSelectMultipleListFieldValue(value);

    case APIFieldType.DATE_ONLY_RANGE: {
      return fieldValueFormatters.formatDateOnlyRangeFieldValue(value, locale);
    }

    case APIFieldType.DATE_TIME_RANGE: {
      return fieldValueFormatters.formatDateTimeRangeFieldValue(value, locale);
    }

    case APIFieldType.USER: {
      return formatUserField(value);
    }

    default:
      return null;
  }
};

export { formatFieldValueToText };
